/** Normalize profile document detail rows to { label, value, confidence }. */
export function documentDetailRows(documentDetails) {
  if (!Array.isArray(documentDetails)) return []
  return documentDetails
    .map((row) => {
      const label = String(row?.Name ?? row?.name ?? row?.field ?? '').trim()
      const value = String(row?.Content ?? row?.content ?? row?.value ?? '').trim()
      if (!label && !value) return null
      const confRaw = row?.Confidence ?? row?.confidence
      const confidence =
        confRaw == null || confRaw === ''
          ? null
          : Math.round(Number(confRaw) <= 1 ? Number(confRaw) * 100 : Number(confRaw))
      return { label: label || 'Field', value: value || '—', confidence }
    })
    .filter(Boolean)
}

export function collectIdentityDocuments({ profileData, otherDocuments = [], ocrNameMismatch }) {
  const docs = []

  if (profileData?.CreatedDocumentDetails?.length) {
    const typeRow = profileData.CreatedDocumentDetails.find((r) =>
      /documenttype|document type/i.test(String(r?.Name || r?.name || ''))
    )
    const docType = typeRow?.Content || typeRow?.content || "Driver's licence"
    docs.push({
      id: 'onboarding',
      title: String(docType),
      subtitle: 'Profile creation document',
      status: profileData.DVSStatus,
      capturedAt: profileData.CreatedDT,
      fields: documentDetailRows(profileData.CreatedDocumentDetails),
      warning: ocrNameMismatch
        ? `Document OCR: ${ocrNameMismatch.ocrName} · Profile: ${ocrNameMismatch.profileName}`
        : null,
      defaultOpen: Boolean(ocrNameMismatch),
    })
  }

  if (profileData?.RecentDocumentDetails?.length) {
    const typeRow = profileData.RecentDocumentDetails.find((r) =>
      /documenttype|document type/i.test(String(r?.Name || r?.name || ''))
    )
    docs.push({
      id: 'recent-dvs',
      title: typeRow?.Content || typeRow?.content || 'Recent identity document',
      subtitle: 'Latest DVS capture',
      status: profileData.DVSStatus,
      capturedAt: profileData.LUT,
      fields: documentDetailRows(profileData.RecentDocumentDetails),
    })
  }

  for (const d of otherDocuments || []) {
    docs.push({
      id: `${d.source || 'doc'}-${d.id}`,
      title: d.doc_type || d.kind || 'Identity document',
      subtitle: [d.issuing_country, d.used_for].filter(Boolean).join(' · ') || 'On file',
      status: d.status,
      capturedAt: d.captured_at,
      meta: d.doc_number_masked,
      fields: [],
      document: d,
    })
  }

  return docs
}
